<template>
  <div>
    <div class="mx-4 my-2" v-if="subscription">
      <b-message type="is-danger" v-if="subscriptionIsMalformed">
        This subscription object is malformed. It's missing the data limit, NMS Id or network identifiers. Please verify it was created according to spec.
      </b-message>
      <div class="card">
        <div class="card-header">
          <p class="card-header-title">Overview</p>
        </div>
        <div class="card-content">
          <SubscriptionOverviewComponent />
        </div>
      </div>
      <div class="card mt-4" v-if="terminals?.length">
        <div class="card-header">
          <p class="card-header-title">Terminals</p>
        </div>
        <div class="card-content">
          <div>
            <ul>
              <li v-for="t in terminals" :key="t.id">
                {{ t.serial }} / <router-link :to="{ name: 'terminalOverview', params: { id: t.id } }">{{t.name}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="card mt-4">
        <header class="card-header">
          <p class="card-header-title">Monthly Usage</p>
        </header>
        <div class="card-content">
          <div>
            <SubscriptionUsageChartComponent />
          </div>
        </div>
      </div>
    </div>
    <b-loading :is-full-page="false" v-model="subscriptionLoading" :can-cancel="false"></b-loading>
  </div>
</template>
<script setup>
import { computed } from 'vue';

import { useTerminalsStore } from '../../terminals/terminals-store';
import { useSubscriptions2Store } from '../subscriptions2-store';
import SubscriptionOverviewComponent from '../components/SubscriptionOverviewComponent.vue';
import SubscriptionUsageChartComponent from '../components/SubscriptionUsageChartComponent.vue';

const store = useSubscriptions2Store();
const terminalStore = useTerminalsStore();

const subscription = computed(() => store.state.subscription);
const subscriptionLoading = computed(() => store.state.subscriptionLoading);
const terminals = computed(() => terminalStore.state.terminalsForSubscription);

// eslint-disable-next-line vue/return-in-computed-property
const subscriptionIsMalformed = computed(() => {
  if (!subscription?.value?.dataLimitInGb || !subscription?.value?.networkIdentifiers || !subscription?.value?.nmsId) return true;
  return false;
});
</script>
